import type { Dispatch, SetStateAction } from 'react';
import { createContext } from 'react';

type SortPreferenceState = [string, Dispatch<SetStateAction<string>>];
export const SortPreferenceContext = createContext<SortPreferenceState | null>(null);
